import Konva from "konva";
import { IMarkupText } from "../../IMarkupText";

export class KonvaText implements IMarkupText {
  private _ref: Konva.Text;
  private readonly TEXT_FONT_FAMILY = "Calibri";

  constructor(
    params: { position: { x: number; y: number }; text: string; fontSize: number; color: string; rotation: number },
    ref = null
  ) {
    if (ref) {
      this._ref = ref;
      return;
    }

    if (!params || !params.text) return;

    this._ref = new Konva.Text({
      x: params.position.x,
      y: params.position.y,
      text: params.text,
      fontSize: params.fontSize ?? 34,
      fontFamily: this.TEXT_FONT_FAMILY,
      fill: params.color ?? "#ff0000",
      align: "left",
      draggable: true,
      rotation: params.rotation ?? 0,
    });
  }
  ref() {
    return this._ref;
  }

  id(): string {
    return this._ref.id();
  }

  enableMouseEditing(value: boolean) {
    this._ref.draggable(value);
  }

  type(): string {
    return "text";
  }

  setColor(hex: string) {
    this._ref.fill(hex);
  }

  getColor(): string {
    return this._ref.fill();
  }

  delete() {
    this._ref.destroy();
    this._ref = null;
  }

  getText(): string {
    return this._ref.text();
  }

  setText(text: string): void {
    this._ref.text(text);
  }

  getPosition(): { x: number; y: number } {
    return this._ref.getPosition();
  }

  setPosition(x: number, y: number) {
    this._ref.setPosition({ x, y });
  }

  getFontSize() {
    return this._ref.fontSize();
  }
  setFontSize(size: number) {
    this._ref.fontSize(size);
  }
}
